<template>
  <section class="container px-0" id="cmp_imager">
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="13 30 395 250.6"
      style="
        enable-background: new 0 0 1900 1270;
        width: 80%;
        height: 400px;
        max-width: 1000px;
        margin: 0 auto;
        display: block;
        overflow: visible;
      "
      xml:space="preserve"
      class="pdf-item"
      id="svg-image"
      crossorigin="anonymous"
    >
      <g id="Cicloprato_Framekit" v-if="getFrame != null">
        <image
          crossorigin="anonymous"
          id="BikeFramekit"
          :width="getFrame.width"
          :height="getFrame.height"
          :data-name="getFrame['data-name']"
          :href="
            '/configurator/configurations/' +
            bikeConfiguration[0]?.directory +
            '/' +
            getFrame['data-href']
          "
          :transform="getFrame.transform"
        ></image>
      </g>
      <g
        :data-idcat="catId"
        v-for="[catId, group] in getComponents"
        v-bind:key="catId"
        :id="'gcmp_' + catId"
      >
        <image
          crossorigin="anonymous"
          v-for="image in group"
          v-bind:key="image.id"
          :id="'cmp_' + image.component_id"
          :width="image.width"
          :height="image.height"
          :data-name="image['data-name']"
          :data-href="
            '/configurator/configurations/' +
            bikeConfiguration[0]?.directory +
            '/' +
            image['data-href']
          "
          :src="
            '/configurator/configurations/' +
            bikeConfiguration[0]?.directory +
            '/' +
            image['data-href']
          "
          :transform="image.transform"
          :color-type="image['color_type']"
          :color="image['color']"
        ></image>
      </g>
    </svg>
  </section>
</template>

<script>
export default {
  name: "configurator-imager",
  data() {
    return {};
  },
  props: ["bike", "results", "componentsConfig", "bikeConfiguration", "where"],
  methods: {
    refreshComponent: function () {
      if (this.results != null) {
        for (const [key, value] of Object.entries(this.results)) {
          if (key != "frame" && key != "colour" && value != null && value.id != null) {
            var elementId = "cmp_" + value.id;
            var element;

            if (value.colour != null) {
              element = document.querySelectorAll(
                "#" + elementId + '[color="' + value.colour + '"]'
              );
              if (element == null) {
                element = document.querySelectorAll("#" + elementId);
              }
            } else {
              element = document.querySelectorAll("#" + elementId);
            }

            if (element != null) {
              Array.prototype.forEach.call(element, function (node) {
                let hrefValue = node.dataset.href;
                node.setAttribute("href", hrefValue);
              });
            }
          }

          if (key == "colour") {
            var primaryCol = document.querySelectorAll(
              '#gcmp_25 image[color="' + value.primaryColor + '"][color-type="0"]'
            );
            Array.prototype.forEach.call(primaryCol, function (node) {
              node.setAttribute("href", node.dataset.href);
            });

            // primaryCol.setAttribute("href", primaryCol.dataset.href);

            if (
              this.bikeConfiguration[0] !== undefined &&
              this.bikeConfiguration[0].bike_id != 23 &&
              this.bikeConfiguration[0].bike_id != 20 &&
              this.bikeConfiguration[0].bike_id != 16
            ) {
              var secondaryCol = document.querySelectorAll(
                '#gcmp_25 image[color="' + value.secondaryColor + '"][color-type="1"]'
              );
              Array.prototype.forEach.call(secondaryCol, function (node) {
                node.setAttribute("href", node.dataset.href);
              });
            }
          }
        }
      }
    },
  },
  computed: {
    getFrame: function () {
      for (let [catId, subGroup] of Object.entries(this.componentsConfig)) {
        let group = this.componentsConfig[catId];
        if (group != null) {
          for (let i = 0; i < group.length; i++) {
            let configurationLine = group[i];
            if (configurationLine.component_type_id == 25) {
              return configurationLine;
            }
          }
        }
      }
      return null;
    },
    getComponents: function () {
      let ret = {};
      ret = Object.entries(this.componentsConfig);

      let indexToRemove = 0;
      let exit = false;

      for (const [catId, group] of Object.entries(this.componentsConfig)) {
        indexToRemove++;
        for (const [configurationLine, index] in group) {
          /* if (configurationLine.component_type_id == 25 || catId == 25) {
            exit = true;
            break;
          } */
        }
        if (exit) {
          break;
        }
      }

      // delete ret[indexToRemove - 1];
      //const newRet = ret.filter((a) => a);
      //return newRet;
      //return newRet.reverse();
      /**/
      let finalC = ret.filter((a) => a);

      // ordinamento predefinito
      let catOrders = ["25", "4", "5", "6", "8", "9", "11", "10", "14", "7", "12", "27"];

      if (this.bikeConfiguration[0] !== undefined) {
        if (this.bikeConfiguration[0].bike_id == 17) {
          catOrders = ["25", "4", "5", "6", "8", "9", "11", "10", "14", "7", "23"];
        } else if (this.bikeConfiguration[0].bike_id == 18) {
          catOrders = [
            "25",
            "4",
            "5",
            "6",
            "8",
            "9",
            "11",
            "10",
            "14",
            "7",
            "12",
            "27",
            "23",
          ];
        } else if (
          this.bikeConfiguration[0].bike_id == 16 ||
          this.bikeConfiguration[0].bike_id == 21
        ) {
          catOrders = ["25", "4", "5", "6", "8", "9", "11", "10", "14", "7", "12", "27"];
        } else if (this.bikeConfiguration[0].bike_id == 23) {
          catOrders = [
            "25",
            "4",
            "5",
            "6",
            "8",
            "9",
            "11",
            "10",
            "14",
            "7",
            "12",
            "27",
            "23",
          ];
        } else if (this.bikeConfiguration[0].bike_id == 24) {
          catOrders = [
            "25",
            "4",
            "5",
            "6",
            "8",
            "9",
            "11",
            "10",
            "14",
            "7",
            "12",
            "27",
            "23",
          ];
        }
      }
      // let catOrders = ["25", "4", "5", "6", "8", "9","10","11","14","7","23"];

      let catById = {};
      for (let i in finalC) {
        let keyid = "" + finalC[i][0];
        catById[keyid] = finalC[i];
      }
      let finalCOrderd = [];

      for (let o in catOrders) {
        let keyidO = catOrders[o];
        let val = catById[keyidO];

        if (val !== undefined) {
          finalCOrderd.push(val);
        }
      }

      return finalCOrderd;
    },
  },
  mounted() {
    let t = this;
    setTimeout(function () {
      t.refreshComponent();
    }, 400);

    setTimeout(function () {
      const svgElement = document.getElementById("svg-image");
      const viewBox = svgElement.getAttribute("viewBox").split(" ");
      const svgWidth = viewBox[2];
      const svgHeight = viewBox[3];

      // imposta la larghezza e l'altezza basate sul viewBox
      // svgElement.style.setProperty("width", 200);
      // svgElement.style.setProperty("height", svgHeight);
    }, 1000);
  },
};
</script>

<style lang="scss" scoped>
#cmp_imager {
  #swg-image {
    /*max-width: 940px;*/
  }
  /*
  @media (min-width: 1000px) and (min-height: 840px){
    height: 100%;
    position: relative;
    overflow: hidden;
    svg {
      position: absolute;
      transform: translateY(-10%);
    }
  }
  */
}
</style>
